module.exports = __webpack_public_path__ + "static/media/03-1-galeria-05-valentino-mobile@2x.11f512f3.jpg";